import clsx from "clsx";
import { useState } from "react";
import { useParams } from "react-router-dom";

export const AdminMenu = () => {
  const { router } = useParams();
  const [collpased, setCollpased] = useState(true);

  const links = [
    {
      title: "Repair List",
      href: "/",
    },

    {
      title: "Repair Report",
      href: "/reports/repairments",
    },

    {
      title: "Return Report",
      href: "/reports/return",
    },
    {
      title: "Receive Report",
      href: "/reports/receive",
    },
  ];
  return (
    <nav className="bg-white border-gray-200 dark:bg-gray-900">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <a className="flex items-center space-x-3 rtl:space-x-reverse">
          {/* <img
            src="https://cottagemusicinstitute.com/wp-content/themes/cmi/images/logo@3x.png"
            className="h-8"
            alt="Flowbite Logo"
          /> */}
        </a>
        <button
          onClick={() => setCollpased((c) => !c)}
          data-collapse-toggle="navbar-default"
          type="button"
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          aria-controls="navbar-default"
          aria-expanded="false"
        >
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div
          className={clsx(
            "hidden w-full md:block md:w-auto",
            !collpased && "!block"
          )}
          id="navbar-default"
        >
          <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
            {links.map((link) => {
              // const isActive = router!.toLowerCase().includes(link.href);
              const isActive = false;
              return (
                <li key={link.title}>
                  <a
                    href={link.href}
                    className={clsx("menu-item", isActive && "active")}
                  >
                    {link.title}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </nav>
  );
};
